<div class="data-key-editor-wrapper">
  <input
    #dataKeyInput
    type="text"
    class="form-control form-control-sm data-key-input"
    [value]="value"
    (input)="onInputChange($event)"
    [pTooltip]="(editMode ? 'DATA_KEY_CHANGE_WARNING' : '') | translate"
    tooltipPosition="top"
    [readonly]="!editMode"
    [class.editable-mode]="editMode"
    [class.has-error]="hasError"
    [disabled]="disabled"
  />
  @if (!editMode) {
    <p-button 
      icon="pi pi-pencil" 
      styleClass="p-button-rounded p-button-text data-key-edit-btn"
      [pTooltip]="'EDIT' | translate"
      tooltipPosition="top"
      (onClick)="enterEditMode()"
    />
  } @else {
    <div class="data-key-action-btns">
      <p-button 
        icon="pi pi-check" 
        styleClass="p-button-rounded p-button-text p-button-success data-key-save-btn"
        [pTooltip]="'SAVE' | translate"
        tooltipPosition="top"
        [disabled]="!hasChanges"
        (onClick)="saveChanges()"
      />
      <p-button 
        icon="pi pi-times" 
        styleClass="p-button-rounded p-button-text p-button-danger data-key-cancel-btn"
        [pTooltip]="'CANCEL' | translate"
        tooltipPosition="top"
        (onClick)="cancelEdit()"
      />
    </div>
  }
</div>
